
export default {
    'reservation-stepper-step_1': 'Időpont kiválasztása',
    'reservation-stepper-step_2': 'Jegyek kiválasztása',
    'reservation-stepper-step_3': 'Személyes adataok és fizetési mód megadása',
    'reservation-stepper-total-label': 'Végösszeg',
    'reservation-stepper-purchase': 'Megveszem',
    'reservation-stepper-submit': 'Foglalás elküldése'
};
